<script setup>
import { ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import useValidation from "@/utils/helpers/validations";
import AuthLayout from "@/views/layouts/AuthLayout.vue";

const { checkEmailValidation } = useValidation();
const authStore = useAuthStore();

const email = ref(null);
let isValidEmail = ref(true);
let isError = ref(false);
let isSend = ref(false);
let isSubmitted = ref(false);

const validEmail = () => {
  isError.value = false;
  isValidEmail.value = checkEmailValidation(email.value);
};

const onSubmit = () => {
  isError.value = false;
  isSubmitted.value = true;
  authStore
    .forgetPassword({ email: email.value })
    .then(() => { isSend.value = true; })
    .catch(() => {
      isError.value = true;
      isSubmitted.value = false;
    });
};
</script>

<template>
  <AuthLayout>
    <div class="auth-card">
      <div class="auth-logo-wrap">
        <img class="auth-logo-img" src="@/assets/images/logo/hiddenox.svg" alt="Ravo" />
        <span class="auth-logo-text">Ravo</span>
      </div>

      <!-- Send form -->
      <div v-if="!isSend">
        <p class="welcome-message">FORGOT PASSWORD</p>
        <p class="third-welcome-message" style="text-align:center; margin-bottom:28px;">
          Enter your email address and we'll send you a password reset link.
        </p>

        <div class="auth-field-wrap">
          <span class="p-float-label auth-float">
            <PInput
              id="fp-email"
              :model-value="email"
              @input="email = $event.target.value; validEmail()"
              type="email"
              :class="{ 'p-invalid': !isValidEmail || isError }"
              class="auth-pinput"
              autocomplete="email"
            />
            <label for="fp-email">Email address</label>
          </span>
          <small v-if="!isValidEmail" class="auth-field-error">Invalid email address.</small>
          <small v-if="isError" class="auth-field-error">Email not found. Please try again.</small>
        </div>

        <button
          @click="onSubmit"
          :disabled="!email || !isValidEmail || isSubmitted"
          type="button"
          class="auth-submit-btn"
        >
          SEND RESET LINK
          <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
        </button>

        <p class="forth-welcome-message" style="margin-top: 20px;">Remembered your password?</p>
        <router-link class="auth-link" to="/login" style="display:block; text-align:center; margin-top:8px;">
          Back to Login
        </router-link>
      </div>

      <!-- Success state -->
      <div v-else class="text-center" style="padding: 16px 0;">
        <div class="auth-success-icon">
          <i class="bi bi-envelope-check"></i>
        </div>
        <p class="first-success-card-email-message" style="margin: 20px 0 8px;">Check your email</p>
        <p class="second-success-card-email-message">
          We sent a password reset link to<br />
          <strong>{{ email }}</strong>
        </p>
        <router-link class="auth-link" to="/login" style="display:block; text-align:center; margin-top:24px;">
          Back to Login
        </router-link>
      </div>
    </div>
  </AuthLayout>
</template>
